define('FileUploadPDP.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function FileUploadPDPModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/Main/SuiteScript2/FileUploadPDP.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    FileUploadPDPModel.prototype = Object.create(SCModel.prototype);
    FileUploadPDPModel.prototype.constructor = FileUploadPDPModel;
 
    return FileUploadPDPModel
})
